/**
 * @generated SignedSource<<decd2a25ee1d42fd83c94104d5b7749f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateNotificationSubscriptions = {
  marketing?: boolean | null;
  marketingContactChannels?: ReadonlyArray<string> | null;
  surveyInviteContactChannels?: ReadonlyArray<string> | null;
  surveyInvites?: boolean | null;
  token?: string | null;
};
export type SurveyInvitationsMutation$variables = {
  input: UpdateNotificationSubscriptions;
};
export type SurveyInvitationsMutation$data = {
  readonly updateNotificationContactChannelSubscriptions: {
    readonly message: string | null;
    readonly notificationSubscriptions: {
      readonly id: string;
      readonly surveyInviteContactChannels: ReadonlyArray<string> | null;
    };
  } | null;
};
export type SurveyInvitationsMutation = {
  response: SurveyInvitationsMutation$data;
  variables: SurveyInvitationsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateNotificationSubscriptionsResponse",
    "kind": "LinkedField",
    "name": "updateNotificationContactChannelSubscriptions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NotificationSubscriptions",
        "kind": "LinkedField",
        "name": "notificationSubscriptions",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "surveyInviteContactChannels",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SurveyInvitationsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SurveyInvitationsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4fb8cbdcb822d17fff5c715a889ef3ae",
    "id": null,
    "metadata": {},
    "name": "SurveyInvitationsMutation",
    "operationKind": "mutation",
    "text": "mutation SurveyInvitationsMutation(\n  $input: UpdateNotificationSubscriptions!\n) {\n  updateNotificationContactChannelSubscriptions(input: $input) {\n    message\n    notificationSubscriptions {\n      id\n      surveyInviteContactChannels\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5d6e7cb7ff8f0219dd5a7b4fc595a7da";

export default node;
